const input = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const output = 'NOPQRSTUVWXYZABCDEFGHIJKLMnopqrstuvwxyzabcdefghijklm';
const index = (x) => input.indexOf(x);
const translate = (x) => (index(x) > -1 ? output[index(x)] : x);

export default function rot13(str) {
  return (str || '').split('').map(translate).join('');
}
